module.exports = __webpack_public_path__ + "img/callonetta.8e82de19.jpg";